import { FormBaseLayout } from 'modules/components/layer10';
import React from 'react';
import * as ds from './dataService';
import { StyledTextField } from 'modules/components/layer01';
import { SelectRoleField } from 'modules/components/layer04';
import { Stack } from '@mui/material';



export type InvitePersonFormProps = {
  projectId?: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InvitePersonFormProps) => {
  const [
    fnInvitePerson,
    { loading }
  ] = ds.useInvitePerson();


  const form = ds.useFormState(props.projectId ?? '');

  const handleSubmit = async (cb: () => void) => {
    await fnInvitePerson(form.formState);
    cb();
  };

  return (
    <FormBaseLayout.FC
      isLoading={loading}
      successButtonText='Invite User'
      handleCancel={props.handleClose}
      handleSubmit={() => handleSubmit(props.handleClose)}
    >
      <Stack
        rowGap='1rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('firstName')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('lastName')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('email')}
        />

        <SelectRoleField.FC
          form={form}
          fieldName='roleId'
        />
      </Stack>
    </FormBaseLayout.FC>
  );
};
